/**
 * A React functional component that renders a 403 Forbidden error message.
 * @returns {JSX.Element} A JSX element containing the error message.
 */
function Forbidden() {
  return (
    <div style={{ textAlign: "center", marginTop: "20%" }}>
      <h1>403</h1>
      <h2>Forbidden</h2>
    </div>
  );
}

export default Forbidden;
